import React, { useEffect, useRef, useState } from 'react';

// COMMENTED OUT TEMPORARILY
// import { useNavigate } from 'react-router-dom'; 
// import { Link } from 'react-router-dom'; 
// import { useLocation } from 'react-router-dom';

import '../../styles/Cinema.css';
// import '../../styles/Login.css'; // External CSS file for styles
import { FaPlay } from 'react-icons/fa';
import STREET from '../../video/cinema-trailers/street-trailer.mp4';
import FACE from '../../video/cinema-trailers/face-trailer.mp4';

const Carousel = () => {

  const [showTrailer, setShowTrailer] = useState(false);
  const [currentTrailer, setCurrentTrailer] = useState(null);// <-- New state

 // COMMENTED OUT TEMPORARILY
  // const [selectedMovie, setSelectedMovie] = useState(null);

  // COMMENTED OUT TEMPORARILY
  // const [showSchedulePopup, setShowSchedulePopup] = useState(false);

    const [showMaintenance, setShowMaintenance] = useState(true);  //for maintenance popup of cinema temporarily
  // const [selectedTime, setSelectedTime] = useState("");
  // const [showSignIn, setShowSignIn] = useState(false); // Controls visibility of the sign-in modal
  // const [email, setEmail] = useState(""); // Stores user input for email
  // const [password, setPassword] = useState("");

  // COMMENTED OUT TEMPORARILY
  // const navigate = useNavigate(); // Hook for navigation

const cinemaData = [  
  {
     image: './vscimages/cinema/face-hero.jpg',
     thumb: './vscimages/cinema/face-thumb.jpg',
     title: 'Clayface',
     author: 'Warner Bros.',
     topic: '',
     description: '2026 - PG (Horror | Psychological Thriller | Crime Drama)',
     trailer: FACE
     },
     {
     image: './vscimages/cinema/street-hero.jpg',
     thumb: './vscimages/cinema/street-thumb.jpg',
     title: 'Street Fighter',
     author: 'Columbia Pictures',
     topic: '',
     description: '2026 - PG (Actions | Martial Arts | Adventure)',
     trailer: STREET
     },
    

     
     
    
     
    
  ];

  // POP UP OBJECT
  // const movieData = [
  //     {
  //       id: 1,
  //       image: "./vscimages/cinema/demon-thumb.jpg",
  //       title: "Demon Slayer Infinity Castle",
  //       slug: "demon",
  //       rating: "R-16",
  //       showtimes: ["8:00 PM","11:00 PM"],
  //       date: "2025-08-20",
  //       allowAdvanceBooking: true // added date
  //       },
  //       {
  //       id: 2,
  //       image: "./vscimages/cinema/conjuring-thumb.jpg",
  //       title: "The Conjuring: Last Rites",
  //       slug: "conjuring",
  //       rating: "R-16",
  //       showtimes: ["8:00 PM","11:00 PM"],
  //       date: "2025-09-03",
  //       allowAdvanceBooking: true // added date
  //       }

      
  // ];


 
  // THIS IS FOR SIGNIN BUTTON REDIRECT AFTER CLICKING IT INTO THE SIGNUP PAGE
      // const location = useLocation();

  // THIS IS FOR MOVIECARD BACK BUTTON NAVIGATION

  // COMMENTED OUT TEMPORARILY

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);


 // COMMENTED OUT TEMPORARILY
  // const MovieSection = ({ movies }) => {
  //   const [selectedDate, setSelectedDate] = useState("");
  //   // const navigate = useNavigate();

  //   const handleDateChange = (e) => {
  //     setSelectedDate(e.target.value);
  //   };
  
  //   const filteredMovies = selectedDate
  //     ? movies.filter((movie) => movie.date === selectedDate)
  //     : movies;

      
      
      
  
  //   return (
  //     <>
             

  //     <div className="movie-section">
  //       <div className="dropdown-wrapper-left">
  //         <select 
  //           value={selectedDate} 
  //           onChange={handleDateChange} 
  //           className="date-dropdown"
  //         >
  //           <option value="">Select Date</option>
  //           {Array.from(new Set(movies.map(movie => movie.date))).map((date, index) => (
  //             <option key={index} value={date}>
  //               {new Date(date).toLocaleDateString('en-US', {
  //                 month: 'long',
  //                 day: 'numeric',
  //                 year: 'numeric'
  //               })}
  //             </option>
  //           ))}
  //         </select>
  //       </div>
  
  //       <div className="movie-cards-container">
  //         {filteredMovies.map((movie) => (
  //           <div className="movie-card" key={movie.id}>
  //           <img src={movie.image} alt={movie.title} className="movie-thumbnail" />
  //           <div className="movie-title">{movie.title}</div>

  //           {/* FOR ADVANCE SCREENING LABEL */}
  //          {movie.allowAdvanceBooking && new Date(movie.date) > new Date() && (
  //           <div className="advance-badge" title="You can buy tickets early for this movie.">
  //            Advance Ticket Sale
  //           </div>
  //         )}



  //           {/* THIS IS FOR MAKING THE MOVIE HAVE NEXT ATTRACTION AND COMING SOON LABELS */}
  //           <div className="movie-label">
  //             {(() => {
  //               // const today = new Date();
  //               const today = new Date();
  //               today.setHours(0, 0, 0, 0); // Reset time to midnight

  //               // const movieDate = new Date(movie.date);
  //               const movieDate = new Date(movie.date);
  //               movieDate.setHours(0, 0, 0, 0); // Ensure fair comparison
  //               const TwoWeeks = new Date();
  //               TwoWeeks.setDate(today.getDate() + 14);

  //               if (movieDate <= today) {
  //                 return <span className="now-showing">Now Showing</span>;
  //               } else if (movieDate > today && movieDate <= TwoWeeks) {
  //                 return (
  //                           <>
  //                             <span className="next-attraction">Next Attraction</span>
  //                             <div className="release-date">On {movieDate.toLocaleDateString('en-US', {
  //                               month: 'long',
  //                               day: 'numeric',
  //                               year: 'numeric'
  //                             })}</div>
  //                           </>
  //                         );
  //               } else {
  //                 return (
  //                         <>
  //                           <span className="coming-soon">Coming Soon</span>
  //                            <div className="release-date"> On {movieDate.toLocaleDateString('en-US', {
  //                             month: 'long',
  //                             day: 'numeric',
  //                             year: 'numeric'
  //                           })}</div> 
  //                         </>
  //                       );
  //               }
  //             })()}
  //           </div>
                
  //            {(() => {
  //                   const today = new Date();
  //                   const movieDate = new Date(movie.date);
  //                   const TwoWeeks = new Date();
  //                   TwoWeeks.setDate(today.getDate() + 14);

  //                   const isNowShowing = movieDate <= today;
  //                   const isNextAttraction = movieDate > today && movieDate <= TwoWeeks;
  //                   const isComingSoon = movieDate > TwoWeeks;

  //                   const canBuy = isNowShowing || isNextAttraction || (isComingSoon && movie.allowAdvanceBooking);

  //                   return canBuy ? (
  //                     <Link to={`/buytickets/${movie.slug}`}>
  //                       <button className="buy-button">Buy Now</button>
  //                     </Link>
  //                   ) : null;
  //             })()}
  //         </div>
          
  //         ))}
  //       </div>
        
  //     </div>
  //     </>
  //   );

    
  // };
  
  

   // Stores user input for password

   // COMMENTED OUT TEMPORARILY
  // const [scheduleDetails, setScheduleDetails] = useState({
  //   name: '',
  //   date: '',
  //   time: '',
  // });
      
      
  
  //   return (
  //     <>
             

  //     <div className="movie-section">
  //       <div className="dropdown-wrapper-left">
  //         <select 
  //           value={selectedDate} 
  //           onChange={handleDateChange} 
  //           className="date-dropdown"
  //         >
  //           <option value="">Select Date</option>
  //           {Array.from(new Set(movies.map(movie => movie.date))).map((date, index) => (
  //             <option key={index} value={date}>
  //               {new Date(date).toLocaleDateString('en-US', {
  //                 month: 'long',
  //                 day: 'numeric',
  //                 year: 'numeric'
  //               })}
  //             </option>
  //           ))}
  //         </select>
  //       </div>
  
  //       <div className="movie-cards-container">
  //         {filteredMovies.map((movie) => (
  //           <div className="movie-card" key={movie.id}>
  //           <img src={movie.image} alt={movie.title} className="movie-thumbnail" />
  //           <div className="movie-title">{movie.title}</div>

  //           {/* FOR ADVANCE SCREENING LABEL */}
  //          {movie.allowAdvanceBooking && new Date(movie.date) > new Date() && (
  //           <div className="advance-badge" title="You can buy tickets early for this movie.">
  //            Advance Ticket Sale
  //           </div>
  //         )}



  //           {/* THIS IS FOR MAKING THE MOVIE HAVE NEXT ATTRACTION AND COMING SOON LABELS */}
  //           <div className="movie-label">
  //             {(() => {
  //               // const today = new Date();
  //               const today = new Date();
  //               today.setHours(0, 0, 0, 0); // Reset time to midnight

  //               // const movieDate = new Date(movie.date);
  //               const movieDate = new Date(movie.date);
  //               movieDate.setHours(0, 0, 0, 0); // Ensure fair comparison
  //               const TwoWeeks = new Date();
  //               TwoWeeks.setDate(today.getDate() + 14);

  //               if (movieDate <= today) {
  //                 return <span className="now-showing">Now Showing</span>;
  //               } else if (movieDate > today && movieDate <= TwoWeeks) {
  //                 return (
  //                           <>
  //                             <span className="next-attraction">Next Attraction</span>
  //                             <div className="release-date">On {movieDate.toLocaleDateString('en-US', {
  //                               month: 'long',
  //                               day: 'numeric',
  //                               year: 'numeric'
  //                             })}</div>
  //                           </>
  //                         );
  //               } else {
  //                 return (
  //                         <>
  //                           <span className="coming-soon">Coming Soon</span>
  //                            <div className="release-date"> On {movieDate.toLocaleDateString('en-US', {
  //                             month: 'long',
  //                             day: 'numeric',
  //                             year: 'numeric'
  //                           })}</div> 
  //                         </>
  //                       );
  //               }
  //             })()}
  //           </div>
                
  //            {(() => {
  //                   const today = new Date();
  //                   const movieDate = new Date(movie.date);
  //                   const TwoWeeks = new Date();
  //                   TwoWeeks.setDate(today.getDate() + 14);

  //                   const isNowShowing = movieDate <= today;
  //                   const isNextAttraction = movieDate > today && movieDate <= TwoWeeks;
  //                   const isComingSoon = movieDate > TwoWeeks;

  //                   const canBuy = isNowShowing || isNextAttraction || (isComingSoon && movie.allowAdvanceBooking);

  //                   return canBuy ? (
  //                     <Link to={`/buytickets/${movie.slug}`}>
  //                       <button className="buy-button">Buy Now</button>
  //                     </Link>
  //                   ) : null;
  //             })()}
  //         </div>
          
  //         ))}
  //       </div>
        
  //     </div>
  //     </>
  //   );

    
  // };
  
  

   // Stores user input for password

  // const [scheduleDetails, setScheduleDetails] = useState({
  //   name: '',
  //   date: '',
  //   time: '',
  // });

  const carouselRef = useRef(null);
  const sliderRef = useRef(null);
  const thumbnailRef = useRef(null);
  const timeRef = useRef(null);
  const runTimeOutRef = useRef(null);
  const runNextAutoRef = useRef(null);
  const timeRunning = 650;
  const timeAutoNext = 7000;

  useEffect(() => {
    return () => {
      clearTimeout(runTimeOutRef.current);
      clearTimeout(runNextAutoRef.current);
    };
  }, []);

  // COMMENTED OUT TEMPORARILY
  // const images = [
  //   './vscimages/cinema/draagon.jpg'
  // ];

  // const preloadImages = () => {
  //   images.forEach((src) => {
  //     const img = new Image();
  //     img.src = src;
  //   });
  // };

  const handleNext = () => {
    showSlider('next');
  };

  const handlePrev = () => {
    showSlider('prev');
  };

  const showSlider = (type) => {
    const carousel = carouselRef.current;
    const slider = sliderRef.current;
    const thumbnails = thumbnailRef.current;

    if (!carousel || !slider || !thumbnails) return;

    const sliderItems = slider.querySelectorAll('.item');
    const thumbnailItems = thumbnails.querySelectorAll('.item');

    if (!sliderItems.length || !thumbnailItems.length) return;

    carousel.classList.remove('next', 'prev');

    if (type === 'next') {
      slider.appendChild(sliderItems[0]);
      thumbnails.appendChild(thumbnailItems[0]);
      carousel.classList.add('next');
    } else {
      slider.prepend(sliderItems[sliderItems.length - 1]);
      thumbnails.prepend(thumbnailItems[thumbnailItems.length - 1]);
      carousel.classList.add('prev');
    }

    clearTimeout(runTimeOutRef.current);
    runTimeOutRef.current = setTimeout(() => {
      carousel.classList.remove('next');
      carousel.classList.remove('prev');
    }, timeRunning);

    clearTimeout(runNextAutoRef.current);
    runNextAutoRef.current = setTimeout(() => {
      handleNext();
    }, timeAutoNext);
  };

   // COMMENTED OUT TEMPORARILY
  // const handleScheduleClick = (movie) => {
  //   setSelectedMovie(movie);
  //   setShowSchedulePopup(true);
  // };

  // const handleScheduleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Scheduled:', scheduleDetails);
  //   alert(`Scheduled "${selectedMovie.title}" on ${scheduleDetails.date} at ${scheduleDetails.time}`);
  //   setShowSchedulePopup(false);
  //   setScheduleDetails({ name: '', date: '', time: '' });
  // };
  
  return (
    <>
    
      <div className="carousel" ref={carouselRef}>
        <div className="list" ref={sliderRef}>
          {cinemaData.map((movie, index) => (
            <div className="item" key={index}>
              <img src={movie.image} alt={`slide ${index + 1}`} />
              <div className="content">
                <div className="author">{movie.author}</div>
                <div className="title">{movie.title}</div>
                <div className="topic">{movie.topic}</div>
                <div className="des">{movie.description}</div>
                <div className="trailer-buttons">
                  <button onClick={() => {
                    setCurrentTrailer(movie.trailer);
                    setShowTrailer(true);
                  }}>
                    <FaPlay style={{ marginRight: '5px' }} />
                    WATCH TRAILER
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="thumbnail" ref={thumbnailRef}>
          {cinemaData.map((movie, index) => (
            <div className="item" key={index}>
              <img src={movie.thumb} alt={`thumb ${index + 1}`} />
            </div>
          ))}
        </div>

        <div className="arrows">
          <button id="prev" onClick={handlePrev}>&lt;</button>
          <button id="next" onClick={handleNext}>&gt;</button>
        </div>

        <div className="time" ref={timeRef}></div>

        {/* FOR VIDEO POPUP */}
        {showTrailer && currentTrailer && (
            <div className="trailer-popup">
              <div className="trailer-content">
                <button className="trailer-close-btn" onClick={() => {
                  setShowTrailer(false);
                  setCurrentTrailer(null);
                }}>
                  ✕
                </button>
                <video width="100%" controls autoPlay>
                <source src={currentTrailer} type="video/mp4" />
                Your browser does not support the video tag.
              </video>  
              </div>
            </div>
          )}
      </div>

        {/* --- Popup ---- */}
      {showMaintenance && (
        <div className="maintenance-popup">
          <div className="maintenance-content">
            <button
              className="maintenance-close"
              onClick={() => setShowMaintenance(false)}
            >
              ✕
            </button>
            <img
              src="/vscimages/cinema/sched/nov4.jpg"
              alt="Nov 4 - 5, 2026 Movie Schedule"
              className="maintenance-artwork"
            />
          </div>
        </div>
      )}


      {/* CARDS */}
      <section className="movie-cards-section" id='moviecards'>
        <div className="movie-cards-header">
          <div className="movie-cards-title">
          <h2 className="section-title">Movie Schedule</h2>
          {/* <a href='/privacypolicy' className='privacy'>Privacy Policy</a> */}
          </div>
          {/* <MovieSection movies={movieData} /> */}
           <div className="maintenance-artwork-container">
            <img
              src="/vscimages/cinema/sched/oct28.jpg"
              alt="Oct 28 - Nov 3, 2026 Movie Schedule"
              className="maintenance-artwork"
            />
          </div>
        </div>
      </section>


      
    </>
  );
};

export default Carousel;
